<template>
  <div class="columns is-vcentered">
    <div id="submit-container" class="column is-2">
      <button
        id="submit"
        type="submit"
        class="button is-success"
        @click.stop.prevent="submit"
      >
        Submit
      </button>
    </div>
    <div id="not-enough-submissions" class="column is-10 is-hidden">
      <div class="notification is-danger">
        You must fill out at least {{ voteRequirement }} names to submit this form.
      </div>
    </div>
  </div>
</template>

<script>
import bugsnagClient from '@/bugsnag';

export default {
  computed: {
    voteRequirement() {
      return this.$store.state.vote_requirement;
    },
  },
  methods: {
    submit() {
      if (!document.getElementById('survey').reportValidity()) {
        return false;
      }

      if (this.$store.state.vote_count < this.voteRequirement) {
        document.getElementById('not-enough-submissions').classList.remove('is-hidden');
        setTimeout(() => {
          document.getElementById('not-enough-submissions').classList.add('is-hidden');
        }, 5000);
        return false;
      }

      // If no errors, reset the progress bar and submit the reuslts.
      this.$store.dispatch('resetVoteCount');

      const query = this.http_build_query({
        sheet: this.$store.state.google_sheet_title,
        project_id: this.$store.state.project_id,
        uuid: this.$store.state.uuid,
      });

      window.fetch(`//dj5-api.datajoe.com/api/survey?${query}`, {
        body: this.$store.state.submission,
        method: 'post',
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      }).then((res) => {
        if (!res.ok) bugsnagClient.notify(res.statusText);
      }).catch((error) => {
        bugsnagClient.notify(error);
      });

      return this.$router.push('thankyou');
    },
    http_build_query(jsonObj) {
      const keys = Object.keys(jsonObj);
      const values = keys.map(key => jsonObj[key]);

      return keys
        .map((key, index) => `${key}=${values[index]}`)
        .join('&');
    },
  },
};
</script>
